import { request } from '../../utils/request/request';

export function getWorkoderDatail(query) {
  return request({
    url: 'api/WF/v1/GetProcessDetails',
    method: 'get',
    params: query,
  });
}
export function someOtherFunc() {

}
export function GetProcessDetailsNew(query) {
  return request({
    url: 'api/WF/v1/GetProcessDetails_New',
    method: 'get',
    params: query,
  });
}
